import React from 'react';
import { OrderBookRowFieldProps } from '../../../types';

export const OrderBookSidePrice = (props: OrderBookRowFieldProps) => {
  return new Intl.NumberFormat().format(props.metric.price);
};

export default OrderBookSidePrice;
